import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

/**
 * Markdown to HTML, for [innerHTML]. Angular sanitizes what is bound there, so script and event
 * attributes an author might paste are stripped on the way in.
 */
@Pipe({ name: 'markdown' })
export class MarkdownPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    return marked.parse(value, { async: false, gfm: true, breaks: true }) as string;
  }
}
